<script>
    import SelectorWidget from './SelectorWidget.vue';

    export default {
        extends: SelectorWidget,
        methods: {
            render() {
                this.iteration += 1;
                this.setValue();
            }
        }
    }
</script>
